import type { JobDetailData } from "@apis/videoCreatingService";
import type { UserAssetRecord } from "@apis/http/api";

/** 列表项 jobItem.context 的运行时结构（OpenAPI 中为 BaseResponseContext/unknown） */
export type UserAssetJobContext = {
  videoUrl?: string;
  coverImageUrl?: string;
  aspectRatio?: string;
  duration?: number;
  quantity?: number;
  resolution?: string;
  productTitle?: string;
  productImageUrl?: string;
};

export const getJobContext = (record?: UserAssetRecord | null): UserAssetJobContext | undefined =>
  record?.jobItem?.context as UserAssetJobContext | undefined;

export const ASPECT_RATIO_MAP: Record<string, string> = {
  RATIO_9_16: "9:16",
  RATIO_16_9: "16:9",
};

export const formatDate = (date?: number | string) => {
  if (!date) return "-";
  const d = new Date(typeof date === "number" ? date : date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year} / ${month} / ${day}`;
};

export const getRecordVideoUrl = (record?: UserAssetRecord | null) => {
  const context = getJobContext(record);
  return context?.videoUrl || record?.url || undefined;
};

export const getVideoUrl = (jobDetail: JobDetailData | null, record?: UserAssetRecord | null) => {
  return jobDetail?.output?.videoUrl || getRecordVideoUrl(record);
};

export const getAspectRatio = (jobDetail: JobDetailData | null, record?: UserAssetRecord | null) => {
  return jobDetail?.input?.aspectRatio || getJobContext(record)?.aspectRatio;
};
